// third-party
import { FormattedMessage } from "react-intl";

// assets
import { UserOutlined } from "@ant-design/icons";

// icons
const icons = {
  UserOutlined,
};

const b2bUser = {
  id: "b2b-user",
  title: <FormattedMessage id="b2b" />,
  type: "group",
  children: [
    {
      id: "user",
      title: <FormattedMessage id="b2b-user" />,
      type: "item",
      url: "/b2b/user",
      icon: icons.UserOutlined,
      breadcrumbs: false,
    },
  ],
};

export default b2bUser;
